import {
	Box,
	FormControl,
	Grid,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
	getCGDetail,
	getCGForCountry,
	getCGRefData,
	getCustomerCountries,
	setCGState,
} from "../customerGroupSetupSlice";
import Status from "./Status";
import CollapseSection from "../../../../components/ui/CollapseSection";
import CustomButton from "../../../../components/ui/CustomButton";

const h35 = 35;
const w200 = 200;

export default function SearchCG() {
	const cgState = useSelector((store) => store.customerGroupSetup);
	const {
		countries,
		country,
		countryID,
		editFromDate,
		editToDate,
		customerTypes,
		customerType,
		customerTypeCode,
		customerGroups,
		customerGroupName,
		customerGroupID,
		editCGName,
		customerGroupDetail,
		status,
		// customers,
		selCustomers,
		customerLevels,
		customerLevelID,
	} = cgState;
	const dispatch = useDispatch();

	// useEffect(() => {
	//    if (country !== "" && customerTypeCode !== "") {
	//       dispatch(
	//          getCGForCountry({ countryID, customerTypeCode, customerGroupName })
	//       );
	//    }
	// }, [country, customerTypeCode]);

	const minDate = dayjs().add(1, "day");

	useEffect(() => {
		if (
			customerGroupDetail !== null &&
			Object.keys(customerGroupDetail).length > 0
		) {
			setCGDetails();
		}
	}, [customerGroupDetail]);

	useEffect(() => {
		dispatch(setCGState("customerTypes", []));
		dispatch(setCGState("customerGroups", []));
		dispatch(setCGState("customerGroupName", ""));
		dispatch(setCGState("createMessage", ""));
		dispatch(setCGState("createMessageSeverity", ""));
		dispatch(setCGState("createMessageOpen", false));
	}, []);

	function showPopup(message, severity) {
		dispatch(setCGState("popUpMsg", message));
		dispatch(setCGState("popUpSeverity", severity));
		dispatch(setCGState("popUpOpen", true));
	}

	function updateCountry(event) {
		const countryName = event.target.value;
		const countryID = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		dispatch(setCGState("country", countryName));
		dispatch(setCGState("countryID", countryID));
		//reset states because of country change
		resetStatesOnCountryChange();

		dispatch(getCGRefData({ countryID })).then((res) => {
			// when user selects a country a default customer type
			// should get selected. as default the first customer type
			// is set.
			let { customerLevels, customerTypes } = res.payload;
			let firstType = null,
				level = null;
       
			if (customerTypes && customerTypes.length > 0) {
				firstType = customerTypes[0];
				dispatch(setCGState("customerType", firstType.customerTypeName));
				dispatch(setCGState("customerTypeCode", firstType.customerTypeCode));
			}
			if (customerLevels && customerLevels.length > 0) {
				level = customerLevels.find(
					(custLevel) => custLevel.customerLevelID === "SH"
				);
			}
			dispatch(
				getCustomerCountries({
					CountryId: countryID,
					Level: level.customerLevelID,
					Type: firstType.customerTypeCode,
				})
			);
		});
	}

	function resetStatesOnCountryChange() {
		dispatch(setCGState("customerGroupName", ""));
		dispatch(setCGState("customerGroups", []));
		dispatch(setCGState("customerType", ""));
		dispatch(setCGState("customerTypeCode", ""));
		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
		dispatch(setCGState("editCGName", ""));
		dispatch(setCGState("editFromDate", dayjs().add(1, "day")));
		dispatch(setCGState("editToDate", dayjs("2099-12-31T00:00:00.000Z")));
		dispatch(setCGState("status", "None"));
		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
		dispatch(setCGState("customerCountries", []));
		dispatch(setCGState("selCustCountries", []));
		dispatch(setCGState("editComments", ""));
		dispatch(setCGState("customerLevel", ""));
		dispatch(setCGState("customerLevelID", ""));
		dispatch(setCGState("customerName", ""));
		dispatch(setCGState("files", []));
		dispatch(setCGState("customerCountries", []));
		dispatch(setCGState("selCustCountries", []));
	}

	function updateCustomerType(event) {
		const type = event.target.value;
		const typeCode = customerTypes.find(
			(cType) => cType.customerTypeName === type
		).customerTypeCode;
		dispatch(setCGState("customerType", type));
		dispatch(setCGState("customerTypeCode", typeCode));

		//reset states because of type change
		resetStatesOnTypeChange();

		dispatch(
			getCustomerCountries({
				CountryId: countryID,
				Level: customerLevelID,
				Type: typeCode,
			})
		);
	}

	function resetStatesOnTypeChange() {
		dispatch(setCGState("customerGroupName", ""));
		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
		dispatch(setCGState("editCGName", ""));
		dispatch(setCGState("editFromDate", dayjs().add(1, "day")));
		dispatch(setCGState("editToDate", dayjs("2099-12-31T00:00:00.000Z")));
		dispatch(setCGState("status", "None"));
		dispatch(setCGState("customers", []));
		dispatch(setCGState("selCustomers", []));
		dispatch(setCGState("editComments", ""));
		// dispatch(setCGState("customerLevel", ""));
		// dispatch(setCGState("customerLevelID", ""));
		dispatch(setCGState("files", []));
    dispatch(setCGState("customerCountries", []));
    dispatch(setCGState("selCustCountries", []));
	}

	function updateCGName(event) {
		const name = event.target.value;
		if (name === "") {
			return;
		}
		const id = customerGroups.find(
			(group) => group.customerGroupName === name
		).customerGroupID;
		dispatch(setCGState("customerGroupID", id));
		setTimeout(() => {
			getCGDetails(name, id);
		}, [20]);
	}

	// this was the fix for "default customer type selection when country is selected"
	// but below code was not updating customer type for some specific countries.
	// updated fix in updateCountry function
	// useEffect(() => {
	// 	console.log("country", country, "firstType", customerTypes[0]);
	// 	if (!customerType && customerTypes.length > 0) {
	// 		const firstType = customerTypes[0];
	// 		dispatch(setCGState("customerType", firstType.customerTypeName));
	// 		dispatch(setCGState("customerTypeCode", firstType.customerTypeCode));
	// 	}
	// }, [customerTypes, customerType, country]);

	function getCGDetails(name = customerGroupName, id = customerGroupID) {
		if (country === "") {
			showPopup("Please select a country.", "info");
			return;
		}
		if (customerType === "") {
			showPopup("Please select a type.", "info");
			return;
		}
		if (name === "") {
			showPopup("Please select a a customer group.", "info");
			return;
		}
		dispatch(getCGDetail({ customerGroupID: id }));
	}

	function setCGDetails() {
		if (customerGroupDetail !== null) {
			const {
				customerGroupName,
				effectiveStartDate,
				effectiveEndDate,
				status,
				customerlist,
				comments,
				customerGroupLevelCode,
				customerGroupFiles,
			} = customerGroupDetail;
			const startDateDayjs = dayjs(effectiveStartDate);
			const endDateDayjs = dayjs(effectiveEndDate);
			const formattedComments = comments ? comments.replace(/,/g, "\n") : "";
			dispatch(setCGState("editCGName", customerGroupName));
			dispatch(setCGState("editFromDate", startDateDayjs));
			dispatch(setCGState("editToDate", endDateDayjs));
			dispatch(setCGState("status", status));
			dispatch(setCGState("customers", []));
			dispatch(setCGState("selCustomers", customerlist));
			dispatch(setCGState("editComments", formattedComments));

			const level = customerLevels.find(
				(item) => item.customerLevelID === customerGroupLevelCode
			)?.customerLevel;
			dispatch(setCGState("customerLevel", level));
			dispatch(setCGState("customerLevelID", customerGroupLevelCode));
			dispatch(setCGState("files", customerGroupFiles));
		}
	}

	// function updateEditCGName(event) {
	// 	const pattern = /^[a-zA-Z0-9 ]*$/;
	// 	let CGname = event.target.value;

	// 	if(CGname.includes("  ")){
	// 		return;
	// 	}
	// 	if (event.target.value === " ") {
	// 		event.target.value = event.target.value.replace(" ", "");
	// 	} else if (event.target.value.startsWith(" ")) {
	// 		event.target.value = event.target.value.trimStart();
	// 	}
	// 	if (!pattern.test(event.target.value)) {
	// 		event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
	// 	}
	// 	const name = event.target.value;
	// 	dispatch(setCGState("editCGName", name));
	// }

	function updateEditCGName(event) {
		let name = event.target.value;
	  
		// Remove special characters
		name = name.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		name = name.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		name = name.trimStart();
	
	  
		//Dispatch cleaned value
		dispatch(setCGState("editCGName", name));
	}

	function handleFromDate(newDate) {
		dispatch(setCGState("editFromDate", newDate));
		const selected = selCustomers.map((item) => {
		   return {
			  ...item,
			  effectiveStartDate: newDate,
		   };
		});
		dispatch(setCGState("selCustomers", selected));
	 }
  
	 function handleToDate(newDate) {
		const prevToDate=editToDate;
		const fromDate = dayjs(editFromDate).startOf("day");
		const toDate = dayjs(newDate).startOf("day");
  
		if (toDate.diff(fromDate, "day") <7) {
		   showPopup("Validity must be at least 7 days", "info");
		   dispatch(setCGState("editToDate",editToDate));
		   return;
		}
		dispatch(setCGState("editToDate", newDate));
  
		const selected = selCustomers.map((item) => {
		   const dt1 = dayjs(item.effectiveEndDate).startOf("day");
		   const dt2 = dayjs(newDate).startOf("day");
		   const dtPrev = dayjs(prevToDate).startOf("day");
		   let updatedDate;
	 
		   // If effectiveEndDate matches the previousToDate, update it to date
		   if (dt1.isSame(dtPrev)) {
			  updatedDate = dt2.toDate();
		   } else {
			  updatedDate = dt1.isAfter(dt2) ? dt2.toDate() : dt1.toDate();
		   }
	  
		   if (!dt1.isSame(updatedDate)) {
			 return { ...item, effectiveEndDate: updatedDate };
		   }
		   return item;
		});
		dispatch(setCGState("selCustomers", selected));
	 }
	const onSearchCustomerGroups = () => {
		if (country === "") {
			showPopup("Please select a country.", "info");
			return;
		}
		if (customerType === "") {
			showPopup("Please select a type.", "info");
			return;
		}
		if (country !== "" && customerTypeCode !== "") {
			dispatch(
				getCGForCountry({ countryID, customerTypeCode, customerGroupName })
			);
		}
	};
	const onCustomerGroupNameChange = (event) => {
		let updatedValue = event.target.value;
		updatedValue = updatedValue.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		updatedValue = updatedValue.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		updatedValue = updatedValue.trimStart();
		dispatch(setCGState("customerGroupName", updatedValue));
	};

	return (
		<Box>
			{/* COUNTRY, TYPE, SELECT CUSTOMER GROUP, SEARCH */}
			<Box sx={{ mt: 3 }}>
				<Grid
					container
					columns={12}
					spacing={4}
					justifyContent={"space-between"}
				>
					<Grid item sm={6} md={6} lg={6}>
						<Grid container spacing={2}>
							<Grid item sm={6} md={6} lg={6}>
								<FormControl>
									<InputLabel>Country</InputLabel>
									<Select
										value={country}
										label="Country"
										sx={{
											height: h35,

											width: "100%",
											color: "black.main",
											mt: 1,
										}}
										onChange={updateCountry}
									>
										{countries.map((country, index) => {
											return (
												<MenuItem key={index} value={country.countryName}>
													{country.countryName}
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</Grid>

							<Grid item sm={6} md={6} lg={6}>
								<FormControl>
									<InputLabel>Type</InputLabel>
									<Select
										value={customerType}
										label="Type"
										sx={{
											height: h35,
											width: "100%",
											color: "black.main",
											mt: 1,
										}}
										onChange={updateCustomerType}
									>
										{customerTypes.map((type, index) => (
									(type.customerTypeCode === '09') ? (
										<MenuItem key={index} value={type.customerTypeName} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}
								 {customerTypes.some(type => type.customerTypeCode === '09') && (
										<div style={{ width: "100%", borderBottom: "dashed 1px", paddingBottom: "10px" }}></div>
								 )}
								{customerTypes.map((type, index) => (
									(type.customerTypeCode !== '09') ? (
										<MenuItem key={index} value={type.customerTypeName} disabled={!type.customerTypeCode}>
											{type.customerTypeCode ? `${type.customerTypeCode} | ` : ''}{type.customerTypeName}
										</MenuItem>
									) : null
								))}
									</Select>
								</FormControl>
							</Grid>

							<Grid item sm={6} md={6} lg={6}>
								<FormControl fullWidth sx={{ boxSizing: "border-box" }}>
									<TextField
										label="Customer Group Name"
										value={customerGroupName}
										variant="outlined"
										onChange={onCustomerGroupNameChange}
										sx={{
											height: h35,
											width: "100%",
											color: "black.main",
											mt: 1,
											boxSizing: "border-box",
										}}
										InputProps={{ autoComplete: "off" }}
									/>
								</FormControl>
							</Grid>

							<Grid item sm={6} md={6} lg={6}>
								<Box
									sx={{
										display: "flex",
										justifyContent: "flex-end",
										alignItems: "center",
										height: "140%",
									}}
								>
									<CustomButton
										startIcon={<SearchIcon />}
										onClick={onSearchCustomerGroups}
									>
										Search
									</CustomButton>
								</Box>
							</Grid>
						</Grid>
					</Grid>

					<Grid item sm={6} md={6} lg={6}>
						<Box
							sx={{
								borderLeft: 1,
								borderColor: "#c6c6c6",
								paddingLeft: "16px",
								minHeight: "100%",
							}}
						>
							<FormControl className={"fullHeight"} fullWidth sx={{ ml: 1.25 }}>
								<InputLabel shrink htmlFor="select-multiple-native">
									Select Customer Group
								</InputLabel>
								<Select
									multiple
									native
									size="small"
									value={customerGroupName}
									onChange={updateCGName}
									label="Select Customer Group"
									InputProps={{
										id: "select-multiple-native",
									}}
									style={{ width: "97%" }}
								>
									{customerGroups.map((cg, index) => {
										return (
											<option key={index} value={cg.customerGroupName}>
												{cg.customerGroupName} --{cg.status}
											</option>
										);
									})}
								</Select>
							</FormControl>
						</Box>
					</Grid>
				</Grid>
			</Box>

			{/* CUSTOMER GROUP NAME, VALIDITY PERIOD FROM, VALIDITY PERIOD TO */}
			<Box sx={{ mt: 4, mb: 4 }}>
				<CollapseSection title="Define Customer Group">
					<Grid
						container
						columns={8}
						spacing={3}
						mt={1}
						alignContent={"space-between"}
					>
						<Grid item sm={6} md={3} lg={2.8}>
							<TextField
								id="outlined-basic"
								sx={{ color: "black.main" }}
								label="Customer Group Name"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<EditIcon />
										</InputAdornment>
									),
									autoComplete: "off",
								}}
								variant="outlined"
								value={editCGName}
								onChange={updateEditCGName}
							/>
						</Grid>
						<Grid item sm={6} md={2.5} lg={2}>
							<Box sx={{ mt: 0 }}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										disabled
										label="Validity Period From"
										value={editFromDate}
										onChange={(newDate) => handleFromDate(newDate)}
										renderInput={(params) => (
											<TextField
												{...params}
												size="small"
												sx={{ width: w200 }}
											/>
										)}
										format="DD/MM/YYYY"
									/>
								</LocalizationProvider>
							</Box>
						</Grid>
						<Grid item sm={6} md={2.5} lg={2}>
							<Box sx={{ mt: 0 }}>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DatePicker
										minDate={minDate}
										label="Validity Period To"
										value={editToDate}
										onChange={(newDate) => handleToDate(newDate)}
										disabled={
											customerGroupDetail?.isDeactivated === 1 ? true : false
										}
										renderInput={(params) => (
											<TextField
												{...params}
												size="small"
												sx={{ width: w200 }}
											/>
										)}
										format="DD/MM/YYYY"
									/>
								</LocalizationProvider>
							</Box>
						</Grid>
						<Grid item sm={6} md={3} lg={1} mt={0}>
							<Status label={status} />
						</Grid>
					</Grid>
				</CollapseSection>
			</Box>
		</Box>
	);
}
